var BUG_STATUSES = Object.freeze(['open', 'in_progress', 'needs_information', 'ready_to_deploy', 'completed']);
var BUG_SEVERITIES = Object.freeze(['critical', 'high', 'medium', 'low']);
var BUG_PRIORITIES = Object.freeze(['urgent', 'high', 'normal', 'low']);
var BUG_ACTIONS = Object.freeze(['set-title', 'set-status', 'set-severity', 'set-priority', 'set-weight', 'set-assignee', 'untrack', 'retrack']);
var DEFAULT_WEIGHT = 100;
var MIN_WEIGHT = -1000000000;
var MAX_WEIGHT = 1000000000;
var MAX_TITLE_LENGTH = 180;
var COMPLETED_RETENTION_MS = 183 * 24 * 60 * 60 * 1000;
var LABELS = Object.freeze({
  status: {
    open: 'Open',
    in_progress: 'In Progress',
    needs_information: 'Needs Information',
    ready_to_deploy: 'Ready to Deploy',
    completed: 'Completed'
  },
  severity: {
    critical: 'Critical',
    high: 'High',
    medium: 'Medium',
    low: 'Low'
  },
  priority: {
    urgent: 'Urgent',
    high: 'High',
    normal: 'Normal',
    low: 'Low'
  }
});
module.exports = {
  BUG_ACTIONS: BUG_ACTIONS,
  BUG_PRIORITIES: BUG_PRIORITIES,
  BUG_SEVERITIES: BUG_SEVERITIES,
  BUG_STATUSES: BUG_STATUSES,
  COMPLETED_RETENTION_MS: COMPLETED_RETENTION_MS,
  DEFAULT_WEIGHT: DEFAULT_WEIGHT,
  LABELS: LABELS,
  PRIORITY_LABELS: LABELS.priority,
  SEVERITY_LABELS: LABELS.severity,
  STATUS_LABELS: LABELS.status,
  MAX_TITLE_LENGTH: MAX_TITLE_LENGTH,
  MAX_WEIGHT: MAX_WEIGHT,
  MIN_WEIGHT: MIN_WEIGHT
};